module.exports = __webpack_public_path__ + "static/media/1012862.ad546633.png";